import { createEvent, createStore } from 'effector';

export const bunkersInitialState: IInitialState = {
    singleSection: [
      {
        label: '',
        id: 0,
      },
    ],
    multiSection: [
      {
        items: [
          {
            label: '',
            id: 0,
          },
          {
            label: '',
            id: 0,
          },
        ],
      },
    ],
  };

export const setSelectedBunkers = createEvent<any>();

export const $selectedBunkers = createStore(bunkersInitialState).on(
  setSelectedBunkers,
  (state, payload) => {
    return payload;
  },
);


export interface IInitialState {
    singleSection: singleSectionItem[];
    multiSection: multiSectionItem[];
  }
  
  export interface multiSectionItem {
    items: singleSectionItem[];
  }
  
  export interface singleSectionItem {
    label: string;
    id: number;
  }


  export const setSelectedBunkerType = createEvent<number>();

  export const $selectedBunkerType = createStore(0).on(setSelectedBunkerType, (_s, payload) => {
    return payload;
  });

